(function(){
  'use strict';
  var VERSION='4.5.0';
  var TASTE_KEY='flayvr_taste_v420';
  var REVIEW_KEY='flayvr_review_prompt_v450';
  var REVIEW_SNOOZE=30*24*60*60*1000;
  var lastAdd=null;

  function clean(v){return String(v||'').toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ').trim();}
  function handleKey(v){return clean(v).replace(/\s+/g,'-');}
  function keyFor(handle,title){var h=handleKey(handle);return h?'h:'+h:'t:'+clean(title);}
  function readJSON(node,fallback){try{return JSON.parse(node&&node.textContent||JSON.stringify(fallback));}catch(e){return fallback;}}
  function readTaste(){try{var x=JSON.parse(localStorage.getItem(TASTE_KEY)||'null');return x&&x.items?x:{items:{}};}catch(e){return {items:{}};}}
  function readHistory(root){
    var node=(root&&root.querySelector&&root.querySelector('[data-flayvr-customer-history-v431]'))||document.querySelector('[data-flayvr-customer-history-v431]');
    var d=readJSON(node,{});
    d.items=Array.isArray(d.items)?d.items:[];
    d.ordersCount=Number(d.ordersCount||0);
    d.confirmedBuyer=Boolean(d.confirmedBuyer&&d.ordersCount>0);
    return d;
  }
  function findTaste(taste,meta){
    var direct=taste.items&&taste.items[keyFor(meta.handle,meta.title)];
    if(direct)return direct;
    var found=null;
    Object.keys(taste.items||{}).some(function(k){
      var x=taste.items[k]||{};
      if((meta.handle&&handleKey(x.handle)===handleKey(meta.handle))||clean(x.title)===clean(meta.title)){found=x;return true;}
      return false;
    });
    return found;
  }
  function parsePlan(line){
    var raw=String(line.amiMenu||'').trim();
    if(!raw)return [];
    return raw.split('|').map(function(part){
      var p=part.trim(),m=p.match(/^(.+?)\s+(\d+)\s*:\s*(.+)$/);
      return {handle:'',title:(m?m[3]:p).trim(),orderedAt:line.orderedAt||'',source:'ami-plan'};
    }).filter(function(x){return x.title;});
  }
  function rateable(root){
    var h=readHistory(root);if(!h.confirmedBuyer)return [];
    var rows=[];
    h.items.slice().sort(function(a,b){return Date.parse(b.orderedAt||0)-Date.parse(a.orderedAt||0);}).forEach(function(line){
      var plan=parsePlan(line);
      if(plan.length){rows=rows.concat(plan);return;}
      if(String(line.amiCoverage||'').trim())return;
      if(line.title)rows.push({handle:line.handle||'',title:line.title||'',orderedAt:line.orderedAt||'',source:'shopify-product'});
    });
    var seen={};
    return rows.filter(function(x){var k=keyFor(x.handle,x.title);if(!k||seen[k])return false;seen[k]=1;return true;}).slice(0,15);
  }
  function progress(root){
    var items=rateable(root),taste=readTaste(),rated=0;
    items.forEach(function(x){if((findTaste(taste,x)||{}).rating)rated+=1;});
    return {items:items,rated:rated,pending:Math.max(0,items.length-rated),complete:items.length>0&&rated===items.length};
  }
  function emit(name,detail){
    var payload=Object.assign({event:'flayvr_'+name,flayvr_version:VERSION},detail||{});
    try{if(Array.isArray(window.dataLayer))window.dataLayer.push(payload);}catch(e){}
    try{window.dispatchEvent(new CustomEvent('flayvr:analytics',{detail:payload}));}catch(e){}
  }
  function safePath(value,fallback){var v=String(value||'').trim();return v||fallback;}
  function reviewSnoozed(){
    try{var x=JSON.parse(localStorage.getItem(REVIEW_KEY)||'null');return x&&Number(x.until||0)>Date.now();}catch(e){return false;}
  }
  function snoozeReview(){
    try{localStorage.setItem(REVIEW_KEY,JSON.stringify({until:Date.now()+REVIEW_SNOOZE}));}catch(e){}
  }
  function showToast(){
    var toast=document.querySelector('[data-flr45-toast]');
    if(!toast){
      toast=document.createElement('div');toast.className='flr45-toast';toast.dataset.flr45Toast='';
      var text=document.createElement('span');text.textContent='Added to your basket';
      var link=document.createElement('a');var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';link.href=base+'cart';link.textContent='View basket';
      var close=document.createElement('button');close.type='button';close.setAttribute('aria-label','Close');close.textContent='×';
      close.addEventListener('click',function(){toast.classList.remove('is-showing');});
      toast.append(text,link,close);document.body.appendChild(toast);
    }
    toast.classList.add('is-showing');window.clearTimeout(toast._timer);toast._timer=window.setTimeout(function(){toast.classList.remove('is-showing');},3200);
  }
  function activateHash(root){
    var hash=location.hash||'';
    if(hash==='#rate-recent'){
      var pp=root.querySelector('[data-post-purchase-tab]');if(pp&&!pp.hidden){pp.click();return;}
      hash='#buy-again';
    }
    var map={'#buy-again':'buy-again','#last-menu':'last-menu','#new':'new','#not-again':'not-again','#favourites':'reorder'};
    if(map[hash]){var tab=root.querySelector('[data-reorder-tab="'+map[hash]+'"]');if(tab&&!tab.hidden)tab.click();}
  }
  function refreshYourTaste(root){
    var hist=readHistory(root),p=progress(root),next=root.querySelector('[data-retention-next]');
    if(next){
      var title=next.querySelector('[data-retention-next-title]'),copy=next.querySelector('[data-retention-next-copy]'),primary=next.querySelector('[data-retention-next-primary]');
      next.hidden=false;
      if(hist.confirmedBuyer&&p.pending>0){
        if(title)title.textContent='Tell Ami how your recent meals landed.';
        if(copy)copy.textContent=p.pending+' recent meal'+(p.pending===1?' is':'s are')+' still waiting for feedback.';
        if(primary){primary.textContent='Rate recent meals';primary.href='#rate-recent';}
      }else if(hist.confirmedBuyer){
        if(title)title.textContent='Your order history is ready to work harder.';
        if(copy)copy.textContent='Buy something you know, or let Ami use your Taste to find the next thing.';
        if(primary){primary.textContent='Buy again';primary.href='#buy-again';}
      }else{
        var taste=readTaste(),count=Object.keys(taste.items||{}).filter(function(k){return (taste.items[k]||{}).rating;}).length;
        if(title)title.textContent=count?'Your Taste is taking shape.':'Give Ami one useful signal.';
        if(copy)copy.textContent=count?count+' saved Taste rating'+(count===1?'':'s')+' on this browser.':'Rate a meal or update Ami so the next menu starts closer to you.';
        if(primary){primary.textContent=count?'See favourites':'Update with Ami';primary.href=count?'#favourites':safePath(root.dataset.amiPath,'/pages/amyai');}
      }
    }

    var review=root.querySelector('[data-retention-review]'),url=String(root.dataset.reviewUrl||'').trim();
    if(review){
      var should=Boolean(url&&hist.confirmedBuyer&&p.complete&&!reviewSnoozed());
      review.hidden=!should;
      var link=review.querySelector('[data-retention-review-link]');
      if(link){link.href=url;link.textContent=root.dataset.reviewLabel||'Review Flayvr';}
      if(should&&!review.dataset.tracked){review.dataset.tracked='true';emit('review_prompt_view',{source:'your_taste'});}
    }
  }
  function refreshReturn(root){
    var hist=readHistory(root),p=progress(root),taste=readTaste();
    var feedback=Object.keys(taste.items||{}).map(function(k){return taste.items[k]||{};}).filter(function(x){return x.rating;});
    var loved=feedback.filter(function(x){return x.rating==='loved';}).length;
    var fine=feedback.filter(function(x){return x.rating==='fine';}).length;
    var profile=(window.FlayvrReorder&&typeof window.FlayvrReorder.readProfile==='function')?window.FlayvrReorder.readProfile():null;
    var menu=profile&&profile.state&&Array.isArray(profile.state.menu)?profile.state.menu.length:0;
    var eyebrow=root.querySelector('[data-return-eyebrow]'),title=root.querySelector('[data-return-title]'),copy=root.querySelector('[data-return-copy]'),primary=root.querySelector('[data-return-primary]'),login=root.querySelector('[data-return-login]');
    if(hist.confirmedBuyer&&p.pending>0){
      root.hidden=false;
      if(eyebrow)eyebrow.textContent='Ami is waiting on you';
      if(title)title.textContent=hist.firstName?'How was it, '+hist.firstName+'?':'How was your last Flayvr?';
      if(copy)copy.textContent=p.pending+' recent meal'+(p.pending===1?' is':'s are')+' waiting for a quick Taste rating.';
      if(primary){primary.textContent='Rate recent meals';primary.href=safePath(root.dataset.tastePath,'/pages/your-taste')+'#rate-recent';}
      if(login)login.hidden=true;
      return;
    }
    if(hist.confirmedBuyer){
      root.hidden=false;
      if(eyebrow)eyebrow.textContent='Welcome back';
      if(title)title.textContent=hist.firstName?'Welcome back, '+hist.firstName+'.':'Welcome back.';
      if(copy){var parts=[hist.ordersCount+' confirmed Flayvr order'+(hist.ordersCount===1?'':'s')];if(loved)parts.push(loved+' Loved');if(menu)parts.push(menu+' in your last Ami menu');copy.textContent=parts.join(' · ')+'.';}
      if(primary){primary.textContent='Buy again';primary.href=safePath(root.dataset.tastePath,'/pages/your-taste')+'#buy-again';}
      if(login)login.hidden=true;
      return;
    }
    if(loved||fine||menu){
      root.hidden=false;
      if(eyebrow)eyebrow.textContent='Your Taste';
      if(title)title.textContent=loved?loved+' favourite'+(loved===1?'':'s')+' ready when you are':menu?'Your last Ami menu is still here':'Your Taste is taking shape';
      if(copy){var local=[];if(loved)local.push(loved+' Loved');if(fine)local.push(fine+' Fine');if(menu)local.push(menu+' in your last Ami menu');copy.textContent=local.join(' · ')+'.';}
      if(primary){primary.textContent='Reorder favourites';primary.href=safePath(root.dataset.tastePath,'/pages/your-taste')+'#favourites';}
      return;
    }
    root.hidden=true;
  }
  function initYourTaste(root){
    if(root.dataset.flr45Ready===VERSION)return;root.dataset.flr45Ready=VERSION;
    window.setTimeout(function(){refreshYourTaste(root);activateHash(root);},0);
    root.addEventListener('click',function(e){
      var next=e.target.closest('[data-retention-next-primary]');
      if(next){emit('retention_next_action_click',{destination:next.getAttribute('href')||''});if((next.getAttribute('href')||'').charAt(0)==='#'){window.setTimeout(function(){activateHash(root);},0);}}
      var review=e.target.closest('[data-retention-review-link]');if(review){snoozeReview();emit('review_click',{source:'your_taste'});}
      var later=e.target.closest('[data-retention-review-later]');if(later){snoozeReview();var panel=root.querySelector('[data-retention-review]');if(panel)panel.hidden=true;emit('review_dismiss',{source:'your_taste'});}
    });
    emit('your_taste_view',{confirmed_buyer:readHistory(root).confirmedBuyer});
  }
  function initReturn(root){
    if(root.dataset.flr45Ready===VERSION)return;root.dataset.flr45Ready=VERSION;
    window.setTimeout(function(){refreshReturn(root);if(!root.hidden)emit('return_prompt_view',{confirmed_buyer:readHistory(root).confirmedBuyer,pending_feedback:progress(root).pending});},0);
  }
  function bindGlobal(){
    if(document.documentElement.dataset.flr45Global===VERSION)return;document.documentElement.dataset.flr45Global=VERSION;
    document.addEventListener('click',function(e){
      var add=e.target.closest('[data-reorder-add],[data-profile-add]');
      if(add){lastAdd={button:add,source:add.hasAttribute('data-reorder-add')?'reorder':'taste-profile'};emit('add_again_click',{source:lastAdd.source});}
      var rating=e.target.closest('[data-pp-rating],[data-reorder-rating],[data-taste-choice]');
      if(rating){
        var value=rating.dataset.ppRating||rating.dataset.reorderRating||rating.dataset.tasteChoice||'';
        emit('rate_meal',{rating:value,source:rating.hasAttribute('data-pp-rating')?'post_purchase':rating.hasAttribute('data-reorder-rating')?'your_taste':'collection'});
      }
      var signal=e.target.closest('[data-pp-signal]');if(signal)emit('taste_signal',{signal:signal.dataset.ppSignal||'',source:'post_purchase'});
      var amiShortcut=e.target.closest('[data-ami-workspace-shortcut]');if(amiShortcut)emit('ami_workspace_shortcut',{shortcut:amiShortcut.dataset.amiWorkspaceShortcut||''});
      var amiSend=e.target.closest('[data-ami-workspace-send]');if(amiSend)emit('ami_workspace_prompt',{source:'landing'});
      if(e.target.closest('.faw-top-action--taste'))emit('your_taste_click',{source:'ami_workspace'});
      if(e.target.closest('[data-ami-checkout]'))emit('ami_checkout_click',{source:'ami'});
      if(e.target.closest('[data-ami-pdf]'))emit('ami_pdf_click',{source:'ami'});
      var returnPrimary=e.target.closest('[data-return-primary]');if(returnPrimary)emit('return_primary_click',{destination:returnPrimary.getAttribute('href')||''});
      var buyTab=e.target.closest('[data-reorder-tab="buy-again"]');if(buyTab)emit('buy_again_view',{source:'your_taste'});
    },true);
    document.addEventListener('cart:updated',function(){if(lastAdd){showToast();emit('add_again_success',{source:lastAdd.source});lastAdd=null;}});
    document.addEventListener('flayvr:taste:changed',function(){
      document.querySelectorAll('[data-flayvr-retention-v450]').forEach(refreshYourTaste);
      document.querySelectorAll('[data-flayvr-retention-return-v450]').forEach(refreshReturn);
    });
  }
  function init(){
    bindGlobal();
    document.querySelectorAll('[data-flayvr-retention-v450]').forEach(initYourTaste);
    document.querySelectorAll('[data-flayvr-retention-return-v450]').forEach(initReturn);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',function(){window.setTimeout(init,0);});
  window.FlayvrRetention={version:VERSION,refresh:init,emit:emit};
})();
